import { getSvgExportPayload } from '../svg/extractSvg';
import { renderSvgToCanvas } from '../svg/renderSvgToCanvas';

export const printChart = async (options: { container: HTMLElement | null; fileName: string }) => {
  const payload = getSvgExportPayload(options.container);
  if (!payload) {
    return;
  }

  const canvas = await renderSvgToCanvas(payload.svgString, payload.width, payload.height);
  const imageData = canvas.toDataURL('image/png');
  if (!imageData.startsWith('data:image/png')) {
    return;
  }

  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const cleanup = () => {
    iframe.remove();
  };

  const triggerPrint = (iframeWindow: Window) => {
    iframeWindow.focus();
    iframeWindow.print();
    iframeWindow.addEventListener('afterprint', cleanup);
    window.setTimeout(cleanup, 1000);
  };

  iframe.srcdoc = `
    <html>
      <head>
        <title>${options.fileName}</title>
        <style>
          body { margin: 0; padding: 24px; text-align: center; }
          img { max-width: 100%; height: auto; }
        </style>
      </head>
      <body>
        <img id="chart-image" src="${imageData}" alt="${options.fileName}" />
      </body>
    </html>
  `;

  iframe.addEventListener('load', () => {
    const iframeWindow = iframe.contentWindow;
    const iframeDoc = iframe.contentDocument || iframeWindow?.document;
    const imageEl = iframeDoc?.querySelector('#chart-image') as HTMLImageElement | null;
    if (!iframeWindow || !imageEl) {
      cleanup();
      return;
    }

    if (imageEl.complete) {
      triggerPrint(iframeWindow);
    } else {
      imageEl.addEventListener('load', () => triggerPrint(iframeWindow));
      imageEl.addEventListener('error', cleanup);
    }
  });
};
